import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCriticalData = <T>(key: string) =>
  defineStore(`criticalData:${key}`, () => ({
    data: ref<Partial<T>>({}),
  }))();
